import _ from 'lodash';
import Backbone from 'backbone';
import moment from 'moment';

import ErrorView from '@/views/ErrorView/ErrorView';
import Scaffold from '@/Scaffold';
import { userHasRole } from '@/util/RoleUtils';

import SendRemindersView from '../views/SendRemindersView/SendRemindersView';
import GetLastManualAssetEmailReminderByFiscalYear from '../services/GetLastManualAssetEmailReminderByFiscalYear';
import GetExpiringContractDetails from '../services/GetExpiringContractDetails';
import GetAllOrderFormTypes from '../../common/services/GetAllOrderFormTypes';


export default async function loadSendRemindersView() {
  if (!userHasRole('Admin')) {
    showErrorView({ message: 'Unauthorized' });
    return;
  }

  try {
    const currentMonth = Number(moment.utc().format('M'));
    const currentYear = Number(moment.utc().format('YY'));

    let fiscalYear = currentYear;
    if (currentMonth > 9) {
      fiscalYear = currentYear + 1;
    }

    const [manualFundingReminderDateSent, expiringContractsDetails, orderFormTypes] = await Promise.all([GetLastManualAssetEmailReminderByFiscalYear(fiscalYear), GetExpiringContractDetails(), GetAllOrderFormTypes()])    
    return new SendRemindersView({
      model: new Backbone.Model({
        fiscalYear,
        manualFundingReminderDateSent: manualFundingReminderDateSent ? moment(manualFundingReminderDateSent).format('MM/DD/YYYY') : null,
        expiringContractsDetails,
        orderFormTypes
        })
    });
  } catch (err) {
    showErrorView(err);
  }
}

function showErrorView(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'An Error Occurred'
      })
    })
  );
}
